import React from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

type SearchFieldProps = {
  value?: string;
  placeholder?: string;
  className?: string;
  onChange?: (value: string) => void;
  onSubmit?: (value: string) => void;
  inputClassName?: string;
  disabled?: boolean;
};

const SearchField: React.FC<SearchFieldProps> = ({
  value = "",
  placeholder = "Search",
  className = "",
  inputClassName = "",
  onChange,
  onSubmit,
  disabled = false,
}) => {
  const [text, setText] = React.useState<string>(value);

  React.useEffect(() => {
    setText(value);
  }, [value]);

  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === "Enter" && onSubmit) {
      onSubmit(text);
    }
  };

  return (
    <div className={`relative ${className}`}>
      <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" />
      <input
        type="text"
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          if (onChange) onChange(e.target.value);
        }}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className={`w-full pl-9 pr-3 py-2.5 border border-gray-200 rounded-lg focus:ring-4 focus:ring-blue-100 focus:border-blue-600 text-sm font-medium placeholder-gray-500 ${inputClassName}`}
        disabled={disabled}
      />
    </div>
  );
};

export default SearchField;
